var map = {
	"./gallery-wip-clamp-card_00.jpg": 4042,
	"./gallery-wip-clamp-card_01.jpg": 4043,
	"./gallery-wip-clamp-card_02.jpg": 4044,
	"./gallery_00.jpg": 4045,
	"./gallery_01.jpg": 4046,
	"./gallery_02.jpg": 4047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4041;